import { render, staticRenderFns } from "./PassiveStock.vue?vue&type=template&id=0d2106ae&scoped=true"
import script from "./PassiveStock.vue?vue&type=script&lang=js"
export * from "./PassiveStock.vue?vue&type=script&lang=js"
import style0 from "./PassiveStock.vue?vue&type=style&index=0&id=0d2106ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2106ae",
  null
  
)

export default component.exports